<template>
    <div class="modal-overlay">
        <div class="modal">
            <h3>Informe o CPF ou CNPJ</h3>
            <form @submit.prevent="submitCpfCnpj">
                <div>
                    <input
                        class="input-center"
                        type="text"
                        id="cpfCnpjInput"
                        v-mask-cpf-cnpj
                        v-model="cpfCnpj"
                        maxlength="18"
                    />
                </div>

                <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>

                <div class="actions">
                        <button class="btn-confirm" type="submit">Confirmar</button>
                        <button class="btn-cancel" type="button" @click="closeModal">Cancelar</button>
                </div>
            </form>
        </div>
    </div>
</template>
  
<script>
import { Funcoes } from '@/funcoes/utils';
export default {
    data() {
        return {
            cpfCnpj: "",
            errorMessage:""
        };
    },
    methods: {
        submitCpfCnpj() {
            try{
                Funcoes.validarCNPJouCPF(this.cpfCnpj);
                this.$emit("cpfCnpjSubmitted", this.cpfCnpj);
            }catch (error){this.errorMessage=error.message}
        },

        closeModal() {
            this.$emit("close");
        }
    }
};
</script>
  
<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
}
  
.modal {
    background: #fff;
    padding: 20px;
    border-radius: 5px;
    width: 300px;
}
  
.actions {
    margin-top: 15px;
    display: flex;
    justify-content: space-between;
}

.error-message {
    color: red;
    font-weight: bold;
    margin-top: 10px;
}
</style>
  